// @flow

import { Component } from 'react';
import PropTypes from 'prop-types';
import type { Element } from 'react';

type BaseComponentProps = {
  children: Array<Element<*>> | Element<*> | string
};

export default class<Props, State> extends Component<BaseComponentProps & Props, State> {
  static childContextTypes = {
    parent: PropTypes.string
  };

  static contextTypes = {
    parent: PropTypes.string
  };

  getChildContext() {
    return {
      parent: this._type
    };
  }

  get parent() {
    return this.context.parent;
  }

  processChildren() {
    let children = this.props.children;
    return children;
  }
}




// WEBPACK FOOTER //
// ./src/lib/base-component.js